module.exports = __webpack_public_path__ + "static/who-is-jesus-e71341cfa3130ecd48d0c8f638683760.jpg";